<template>
  <div v-wechat-title="title">
    <Header class="m-wap" :extras="extras" platform="wap"></Header>
    <div class="question-main-wap" v-if="!errorMessage">
      <div
        class="question-title-wap"
        :style="{
          display:
            extraItem.extras('titlefont.display') == 1 ? 'block' : 'none',
          color: extraItem.extras('titlefont.color'),
          fontSize: isPreview ? '' : pxOrVw(extraItem.extras('titlefont.size')),
          fontWeight:
            extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : extraItem.extras('titlefont.weight'),
        }"
      >
        {{ title }}
      </div>
      <wap-fields
        :form="questionnaireList"
        :extras="extras"
        :rulesJump.sync="rulesJump"
        ref="questionChild"
      />
      <div
        class="question-footer-wap"
        v-if="isShowBtn"
        @click="submit()"
        :style="{ cursor: isPreview ? 'not-allowed' : 'pointer' }"
      >
        提交
      </div>
    </div>

    <div class="m-currency-content" v-if="errorMessage">
      <form-status
        :status="
          questionaryStatus == 0
            ? 'nostart'
            : questionaryStatus == 2
            ? 'over'
            : 'error'
        "
        :test="errorMessage"
        platform="wap"
      ></form-status>
    </div>

    <CountDown
      ref="count-down"
      :extras="extras"
      platform="wap"
      :totalTimeM="
        questionnaireInfo.isTimeLimit == '2' ? questionnaireInfo.limitTime : 0
      "
      :costTime="costTime"
      @calibration="questionnaireTimeGet"
      @autoSubmit="submit"
    ></CountDown>
  </div>
</template>

<script>
import questionaryMixin from "../../../mixins/questionary";
import templateMixin from "../../../mixins/exam-config";
import WapFields from "@/components/WapFields.vue";
export default {
  name: "examWapQuestionnaire",
  components: {
    WapFields,
  },
  mixins: [templateMixin, questionaryMixin],
};
</script>

<style scoped></style>
